import { ProjectTab } from 'components/project-bar';

export const projectBase = '/project';
export const singleProject = `${projectBase}/:id`;
export const singleProjectView = `${singleProject}/:view`;
